__turbopack_context__.v({
  "collapsibleRow": "styles-module__oZgCMa__collapsibleRow",
  "nativeCheckbox": "styles-module__oZgCMa__nativeCheckbox",
  "sizeButton": "styles-module__oZgCMa__sizeButton",
  "sizeButtonText": "styles-module__oZgCMa__sizeButtonText",
  "sizeButtonsContainer": "styles-module__oZgCMa__sizeButtonsContainer",
  "sizeFilterContents": "styles-module__oZgCMa__sizeFilterContents",
});
